import { useFormikContext } from 'formik';

import { ButtonColors } from 'types';
import { Icon } from 'components/icon';
import { ButtonWithRef } from 'components/button';

import { FormValues as CommonFormValues } from '../types';

import { Form } from './form';
import { CreatePaymentProps } from './types';

export const CreatePayment = ({ ...props }: CreatePaymentProps) => {
  const { setFieldValue, values: commonValues } =
    useFormikContext<CommonFormValues>();

  return (
    <Form
      {...props}
      onSubmit={async (values) => {
        await setFieldValue('returnPayments', [
          ...commonValues.returnPayments,
          values,
        ]);
      }}
      trigger={
        <ButtonWithRef
          text="Payments"
          colorType={ButtonColors.LightBlue}
          icon={<Icon.Cash width={24} height={24} />}
        />
      }
    />
  );
};
